import Link from 'found/Link';
import PropTypes from 'prop-types';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Card, CardBody } from 'reactstrap';

const messages = defineMessages({
  body: {
    id: 'error_boundary.placeholder_error_boundary.not_found_panel.body.message',
    defaultMessage: 'It may have been removed, or the link may be wrong.',
  },
  backLink: {
    id: 'error_boundary.placeholder_error_boundary.not_found_panel.back_link.label',
    defaultMessage: 'Go back to the list',
  },
});

/**
 * Not-found state for a page whose record is missing, with a link back. Unlike
 * the retry modal it offers no Retry, because the record will not come back.
 * @param {object} props - Component props.
 * @param {string} props.title - Localised heading, such as "Meter not found".
 * @param {string} props.backPath - Path of the page to go back to.
 * @returns {React.ReactElement} Not-found panel.
 */
function NotFoundPanel({ title, backPath }) {
  const intl = useIntl();

  return (
    <Card className="mt-4" data-testid="not-found-panel">
      <CardBody>
        <h1 className="h3">{title}</h1>
        <p>{intl.formatMessage(messages.body)}</p>
        <Link to={backPath}>{intl.formatMessage(messages.backLink)}</Link>
      </CardBody>
    </Card>
  );
}

NotFoundPanel.propTypes = {
  title: PropTypes.string.isRequired,
  backPath: PropTypes.string.isRequired,
};

export default NotFoundPanel;
